function initBeginBuyBoxAges(section) {
  if (section.dataset.agesReady) return;
  section.dataset.agesReady = 'true';

  const mediaByOption = new Map();
  section.querySelectorAll('[data-buy-box-plans-media]').forEach((media) => {
    const updateNavState = initBeginBuyBoxPlansGallery(media);
    if (media.dataset.planId) mediaByOption.set(media.dataset.planId, { media, updateNavState });
  });

  const showOptionMedia = (optionId) => {
    if (!mediaByOption.has(optionId)) return;
    mediaByOption.forEach(({ media, updateNavState }, id) => {
      media.hidden = id !== optionId;
      if (id === optionId) updateNavState();
    });
  };

  const preloadHiddenMainImages = () => {
    section.querySelectorAll('[data-buy-box-plans-media][hidden] [data-buy-box-plans-main-img]').forEach((img) => {
      img.loading = 'eager';
    });
  };

  if (document.readyState === 'complete') {
    preloadHiddenMainImages();
  } else {
    window.addEventListener('load', preloadHiddenMainImages, { once: true });
  }

  const buyBox = section.querySelector('[data-buy-box-ages-root]');
  const form = buyBox ? buyBox.querySelector('.begin-buy-box__form') : null;
  if (!buyBox || !form) return;

  const idInput = form.querySelector('input[name="id"]');
  const sellingPlanInput = form.querySelector('[data-buy-box-selling-plan-input]');
  const submitBtn = form.querySelector('[data-buy-box-submit]');
  const buyOnceBtn = form.querySelector('[data-buy-box-ages-buy-once]');
  const buyOncePriceEl = buyOnceBtn ? buyOnceBtn.querySelector('[data-buy-box-ages-buy-once-price]') : null;
  const errorEl = form.querySelector('[data-buy-box-ages-error]');
  const ageChoices = buyBox.querySelectorAll('[data-buy-box-age]');
  const supplyGroups = buyBox.querySelectorAll('[data-buy-box-supply-group]');
  const planCards = buyBox.querySelectorAll('[data-buy-box-plan-card]');

  const showError = (message) => {
    if (errorEl) errorEl.textContent = message;
  };

  const updateBuyOnce = (input) => {
    if (!buyOnceBtn) return;
    const { buyOnceVariantId, buyOncePrice: price } = input.dataset;
    buyOnceBtn.hidden = !buyOnceVariantId;
    if (!buyOnceVariantId) return;
    buyOnceBtn.dataset.variantId = buyOnceVariantId;
    if (buyOncePriceEl && price) buyOncePriceEl.textContent = price;
  };

  const applySupply = (input) => {
    const group = input.closest('[data-buy-box-supply-group]');
    if (group) {
      group.querySelectorAll('[data-buy-box-supply]').forEach((item) => {
        item.classList.toggle('is-selected', item.contains(input));
      });
    }
    if (idInput) idInput.value = input.dataset.variantId;
    if (sellingPlanInput) sellingPlanInput.value = input.dataset.sellingPlanId || '';
    planCards.forEach((card) => {
      card.hidden = card.dataset.buyBoxPlanCard !== input.dataset.optionId;
    });
    showOptionMedia(input.dataset.optionId);
    updateBuyOnce(input);
    showError('');
  };

  const applyAge = (ageId) => {
    ageChoices.forEach((choice) => {
      const input = choice.querySelector('.begin-buy-box-ages__input');
      choice.classList.toggle('is-selected', Boolean(input && input.dataset.ageId === ageId));
    });

    let selectedSupply = null;
    supplyGroups.forEach((group) => {
      const isActive = group.dataset.buyBoxSupplyGroup === ageId;
      group.hidden = !isActive;
      if (!isActive) return;
      selectedSupply =
        group.querySelector('.begin-buy-box-ages__input:checked') ||
        group.querySelector('.begin-buy-box-ages__input');
    });

    if (selectedSupply) {
      selectedSupply.checked = true;
      applySupply(selectedSupply);
    }
  };

  ageChoices.forEach((choice) => {
    const input = choice.querySelector('.begin-buy-box-ages__input');
    if (!input) return;
    input.addEventListener('change', () => {
      if (input.checked) applyAge(input.dataset.ageId);
    });
  });

  supplyGroups.forEach((group) => {
    group.querySelectorAll('.begin-buy-box-ages__input').forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked) applySupply(input);
      });
    });
  });

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const formData = new FormData(form);
    beginBuyBoxAddToCart({
      variantId: formData.get('id'),
      sellingPlanId: formData.get('selling_plan'),
      busyEl: submitBtn || form,
      showError,
    });
  });

  if (buyOnceBtn) {
    buyOnceBtn.addEventListener('click', () => {
      beginBuyBoxAddToCart({ variantId: buyOnceBtn.dataset.variantId, busyEl: buyOnceBtn, showError });
    });
  }
}

function initAllBeginBuyBoxAges() {
  document.querySelectorAll('.begin-buy-box-ages').forEach(initBeginBuyBoxAges);
}

document.readyState !== 'loading'
  ? initAllBeginBuyBoxAges()
  : document.addEventListener('DOMContentLoaded', initAllBeginBuyBoxAges);
